export class DocumentiTipo {
  public IdDocumentoTipo : number = 0;
  public Tipo : string = "";
  public DateIsRequired : boolean = false;
  public ExtraInfoList : DocumentiTipoExtraInfo[] = [];
}

export class DocumentiTipoExtraInfo{
  public IdDocumentiTipoExtraInfo : number = 0;
  public IdDocumentoTipo : number = 0;
  public ExtraInfoLabel : string = "";
  public ExtraInfoType : string = "";
  public Ordinamento : number = 0;
  public IsRequired : boolean = false;
  public ExtraInfoDetailList : DocumentiTipoExtraInfoDetail[] = [];
  //voci aggiunti rispetto al vecchio
  public ExtraInfoValueText : string = "";
  public ExtraInfoValueTextOnlyLetters : string = "";
  public ExtraInfoValueSelect : number = 0;
  public ExtraInfoValueCheckBox : boolean = false;
  public ExtraInfoValueDate : Date | null = null;
}

export class DocumentiTipoExtraInfoDetail{
  public IdDocumentiTipoExtraInfo : number = 0;
  public InfoKey : number = 0;
  public InfoValue : number = 0;
  public InfoSubordinate : number = 0;
  public EnabledDefault : boolean = false;
}

export class GetFileTypesViewModel {
  public FiltroDocumenti : number = 0;
  public IdAnagraficaUtenteEnc : string = "";
}

export class GetFilesViewModelPortas{
  public IdSezione : number = 0;
  public IdAnagraficaUtente : number = 0;
  public IdAzienda : number = 0;
  public IdFilialeDocumento : number = 0;
  public IdSomministrazione : number = 0;
  public IdPrestazione : number = 0;
  public Count : number = 0;
  public Offset : number = 0;
  public IdCategoria : number = 0;
}

export class DocumentiArchivio {
  public IdDocumentiArchivio : number = 0;
  public IdDocumentiArchivioEnc : string = "";
  public IdDocumentoTipo : number = 0;
  public DocumentoTipo : string = "";
  public FileName : string = "";
  public FileExtension : string = "";
  public FileContentType : string = "";
  public DocumentoNome : string = "";
  public IdAnagraficaUtente : number = 0;
  public IdAzienda : number = 0;
  public IdFiliale : number = 0;
  public IdMaster : number = 0;
  public DataDal : Date = new Date();
  public DataDalStr : string = "";
  public DataAl : Date = new Date();
  public DataAlStr : string = "";
  public BlobName : string = "";
  public BlobContainerName : string = "";
  public DateIns : Date = new Date();
  public DateInsStr : string = "";
  public IdUserIns : number = 0;
  public UserIns : string = "";
  public SezioneNome : string = "";
  public IdSezione : number = 0;
  public ExtraInfo : DocumentiArchivioExtraInfoLink[] = [];
  //public FileContents : byte
  public InRinnovo : boolean = false;
  public DataRichiestaRinnovo : Date = new Date();
  public DataRichiestaRinnovoStr : string = "";
  public RinnovoPSRif : string = "";
  public NomeDocumento : string = "";
  public Scaduto : boolean = false;
  public CanDelete : boolean = false;
}

export class DocumentiArchivioDto {
  public UserCanUploadDocument : boolean = false;
  public DocumentiArchivio : DocumentiArchivio[] = [];
  public TotalDocument : number = 0;
}

export class FileDetailViewModel{
  public Id : string = "";
}

export class DocumentiArchivioExtraInfoLink{
  public IdDocumentiTipoExtraInfo : number = 0;
  public ExtraInfoValue : string = "";
  public ExtraInfoLabel : string = "";
  public ExtraInfoType : string = "";
  public Ordinamento : number = 0;
}

export class FilePreviewViewModel {
  public Id : string = "";
}

export class FileArchiveViewModel {
  public IdDocumentoTipo : number = 0;
  public IdFilialeDocumento : number | null = null;
  public DataDal : Date | null = null;
  public DataAl  : Date | null = null;
  public IdAnagraficaUtenteEnc : string = "";
  public IdAziendaEnc : string = "";
  public IdMasterEnc : string = "";
  public ExtraInfo : string = "";
}

export class UpdateExtraInfoViewModel{
  public IdDocumentiArchivioEnc : string = "";
  public IdDocumentiTipoExtraInfo : number = 0;
  public ExtraInfoValue : string = "";
}

export class DocumentiTipoExtraInfoDetailList{
  public Key : string = "";
  public Value : string = "";
}

export class DocumentiTipoSezione{
  public IdSezione : number = 0;
  public SezioneNome : string = "";
  public isOpen : boolean = false;
}

export class DocumentiArchivioGetListDocumentiTipoSezioneViewModel{
  public IdCategoria : number = 0;
  public IdAnagraficaUtenteEnc : string = "";
  public IdAziendaEnc : string = "";
  public IdSomministrazioneEnc : string = "";
  public IdPrestazioneEnc : string = "";
  public IdFilialeDocumentoEnc : string = "";

}

